import DiscoverPage from "./DiscoverPage";

export default DiscoverPage;